import React, { useState, useEffect } from 'react';
import {
    MDBContainer,
    MDBNavbar,
    MDBNavbarBrand,
    MDBNavbarToggler,
    MDBNavbarNav,
    MDBNavbarItem,
    MDBNavbarLink,
    MDBCollapse,
    MDBIcon
} from 'mdb-react-ui-kit';
import BrandLogo from "../assets/images/brandlogo.png";
import { useNavigate } from 'react-router';

function GymNavbar({ scrollToHome, scrollToPlans, scrollToContact, isHiden, logourl }) {
    console.log(isHiden, 'isHiden');
    const navigate = useNavigate();
    const [openNav, setOpenNav] = useState(false);
    const [active, setActive] = useState("home")
    const [imageLoaded, setImageLoaded] = useState(true);

    useEffect(() => {

        const handleImageLoad = () => {
            setImageLoaded(true);
        };

        const handleImageError = () => {
            setImageLoaded(false);
        };

        const imgElement = document.createElement("img");
        imgElement.onload = handleImageLoad;
        imgElement.onerror = handleImageError;
        imgElement.src = logourl;

        return () => {
            imgElement.onload = null;
            imgElement.onerror = null;
        };
    }, [logourl]);
    return (
        <>
            <MDBNavbar expand='lg' light bgColor='light' fixed='top' style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                <MDBContainer fluid className='px-4'>
                    <MDBNavbarBrand href='#' className='brand-logo' onClick={(e) => {
                        e.preventDefault();
                        scrollToHome();
                    }}>
                        <img src={imageLoaded ? logourl : BrandLogo} alt="Brand Logo"></img>
                    </MDBNavbarBrand>
                    <MDBNavbarToggler
                        type='button'
                        aria-expanded='false'
                        aria-label='Toggle navigation'
                        onClick={() => setOpenNav(!openNav)}
                    >
                        <MDBIcon icon='bars' fas />
                    </MDBNavbarToggler>
                    <MDBCollapse navbar open={openNav}>
                        <MDBNavbarNav>
                            <MDBNavbarItem className='navbar-list'>
                                <MDBNavbarLink
                                    active={active == "home" ? true : false}
                                    aria-current='page'
                                    href='#'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        scrollToHome();
                                        setActive("home")
                                    }}
                                >
                                    Home
                                </MDBNavbarLink>
                            </MDBNavbarItem>
                            {!(isHiden.plans) && <MDBNavbarItem className='navbar-list'>
                                <MDBNavbarLink
                                    active={active == "plan" ? true : false}
                                    href='#'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        scrollToPlans();
                                        setActive("plan")
                                    }}
                                >
                                    Plans
                                </MDBNavbarLink>
                            </MDBNavbarItem>}
                            {!(isHiden.contact) && <MDBNavbarItem className='navbar-list'>
                                <MDBNavbarLink
                                    active={active == "contact" ? true : false}
                                    href='#'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        scrollToContact();
                                        setActive("contact")
                                    }}
                                >
                                    Contact
                                </MDBNavbarLink>
                            </MDBNavbarItem>}
                            <MDBNavbarItem className='navbar-list d-flex'>
                                <button className="btnn btn-1 hover-filled-slide-down" onClick={() => navigate('/memberlogin')}>
                                    <span>Login</span>
                                </button>
                            </MDBNavbarItem>
                        </MDBNavbarNav>
                    </MDBCollapse>
                </MDBContainer>
            </MDBNavbar>
        </>
    )
}

export default GymNavbar


